import React from 'react';
import { Tooltips } from '@ftdata/styleguide';
import DefaultIcon from '../defaultIcon';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Google } from '../../../assets/svgs/google.svg';

interface GoogleMapsParams {
    lat_lng: number[];
}

const IconGoogle = <Google />;

const GoogleMapsIcon = ({ lat_lng }: GoogleMapsParams): JSX.Element => {
    const { t } = useTranslation('114');

    const open = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        const url = `https://google.com/maps/search/${lat_lng[0]},${lat_lng[1]}`;
        window.open(url, '_blank');
    };
    return (
        <Tooltips position="left" text={t('show_in_google_maps').toString()}>
            <DefaultIcon onClick={open} icon={IconGoogle} />
        </Tooltips>
    );
};

export default GoogleMapsIcon;
